import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
} from 'react-share';
import MetaTags from 'react-meta-tags';
import Facebook from './img/facebook_logo.png';
import Twitter from './img/twitter_logo.png';
import Email from './img/email_logo.png';
import Whatsapp from './img/whatsapp_logo.png';
import Linkedin from './img/linkedin_logo.png';
import './Teilen.css';

function Teilen({ daten, divHeight, viewportWidth }) {
  const [titel, setTitel] = useState(daten[0].projekt_titel);

  const facebook = (
    <FacebookShareButton
      quote={
        `Schaut mal, was ich auf der HdM Mediathek gefunden habe: ${titel}`
      }
      url={
        `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}`
      }
    >
      <img
        className={viewportWidth > 768 ? 'teilen_logo' : 'teilen_logo_mobil'}
        src={Facebook}
        width="50"
        height="50"
        alt="Auf Facebook teilen"
      />
      <style color="#00FF00" />
    </FacebookShareButton>
  );
  const twitter = (
    <TwitterShareButton
      title={
        `Schaut mal, was ich auf der HdM Mediathek gefunden habe: ${titel}`
      }
      url={
        `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}`
      }
      hashtags={['hdm', 'hdmmediathek', 'lit']}
    >
      <img
        className={viewportWidth > 768 ? 'teilen_logo' : 'teilen_logo_mobil'}
        src={Twitter}
        width="50"
        height="50"
        alt="Auf Twitter teilen"
      />
    </TwitterShareButton>
  );
  const emailButton = (
    <EmailShareButton
      subject={daten[0].projekt_titel}
      body={
        `Schau mal, was ich in der HdM Mediathek gefunden habe: ${titel}\n\n`
      }
      url={
        `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}`
      }
    >
      <img
        className={viewportWidth > 768 ? 'teilen_logo' : 'teilen_logo_mobil'}
        src={Email}
        width="50"
        height="50"
        alt="Über Email teilen"
      />
      <style color="#00FF00" />
    </EmailShareButton>
  );
  const whatsAppButton = (
    <WhatsappShareButton
      title={
        `Schau mal, was ich in der HdM Mediathek gefunden habe: ${titel}\n\n`
      }
      url={
        `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}`
      }
    >
      <img
        className={viewportWidth > 768 ? 'teilen_logo' : 'teilen_logo_mobil'}
        src={Whatsapp}
        width="50"
        height="50"
        alt="Über Whatsapp teilen"
      />
    </WhatsappShareButton>
  );

  const linkedInButton = (
    <LinkedinShareButton
      summary={`Das gibt es in der HdM Mediathek: ${titel}\n\n`}
      source="www.hdm-stuttgart.de"
      url={
        `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}`
      }
    >
      <img
        className={viewportWidth > 768 ? 'teilen_logo' : 'teilen_logo_mobil'}
        src={Linkedin}
        width="50"
        height="50"
        alt="Bei LinkedIn teilen"
      />
    </LinkedinShareButton>
  );
  // Variablen für Metadaten siehe unten in Return () - für Whatsapp Übergabe gedacht
  const nameProject = `${daten[0].projekt_titel}`;
  const linkProject = `https://www.hdm-stuttgart.de/mediathek/projectpage/${daten[0].projekt_ID}/details}`;
  const descriptionProject = `${daten[0].untertitel}`;
  const bildProject = `https://www.hdm-stuttgart.de/mediathek/stage_mediafiles/${daten[0].projekt_ID}/medianight_web/klein.jpg`;

  return (
    <div
      className={viewportWidth > 768 ? 'teilen' : 'teilen-mobil'}
      style={viewportWidth > 768 ? { height: divHeight } : null}
    >
      <MetaTags>
        <meta property="og:title" content={nameProject} />
        <meta property="og:url" content={linkProject} />
        <meta property="og:description" content={descriptionProject} />
        <meta property="og:image" content={bildProject} />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content="de_DE" />
      </MetaTags>

      {facebook}
      {twitter}
      {emailButton}
      {whatsAppButton}
      {linkedInButton}
    </div>
  );
}

export default Teilen;

Teilen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  daten: PropTypes.object.isRequired,
  divHeight: PropTypes.number.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
